import ContactInfo from "components/contact/ContactInfo";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import UserHeroSection from "components/user/UserHeroSection";
import React from "react";
import UserAuth from "components/AuthGaurd/UserAuth";

type Props = {};

export default function Contact({}: Props) {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <UserHeroSection title="Contact Info">
        <ContactInfo />
      </UserHeroSection>
      <footer className="tw-hidden lg:tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
}
